import React,{Fragment , Component} from 'react';
import {HeaderContent} from './Header';

class Header2 extends Component{
	constructor(props) {
		super(props);
		this.state = { isScrolled: false };
		this.handleScroll = this.handleScroll.bind(this);
	}

	componentDidMount() {

        // sidebar open/close

        var Navicon = document.querySelector('.navicon');
        var sidebarmenu = document.querySelector('.myNavbar ');

        function toggleFunc() {
            sidebarmenu.classList.toggle('show');
            Navicon.classList.toggle('open');
        }
        Navicon.addEventListener('click', toggleFunc);


        // Sidenav li open close
        var navUl = [].slice.call(document.querySelectorAll('.navbar-nav > li'));
        for (var y = 0; y < navUl.length; y++) {
            navUl[y].addEventListener('click', function () { checkLi(this) });
        }
		
		
        function checkLi(current) {
            navUl.forEach(el => (current !== el) ? el.classList.remove('open') : '');
            
			setTimeout(() => {
			current.classList.toggle('open');
						
			}, 100);			
        }

		// Toggle glass fixed header after a small scroll.
		this.handleScroll();
		window.addEventListener('scroll', this.handleScroll, { passive: true });
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	handleScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
		const shouldBeScrolled = scrollTop > 8;
		if (shouldBeScrolled !== this.state.isScrolled) {
			this.setState({ isScrolled: shouldBeScrolled });
		}
	}
	render(){
		return(
			<Fragment>
				<style>{`
					/* Keep header sticky always; only apply glass styling after scrolling a little */
					.site-header:not(.header-transparent){
						position: fixed !important;
						top: 0;
						left: 0;
						width: 100%;
						z-index: 1000;
						background: transparent;
					}
					.site-header:not(.header-transparent).header-scrolled{
						backdrop-filter: blur(18px) saturate(180%);
						-webkit-backdrop-filter: blur(18px) saturate(180%);
						background: rgba(12, 14, 22, 0.55);
						transition: background 0.2s ease, backdrop-filter 0.2s ease;
					}
					.site-header:not(.header-transparent).header-scrolled .top-bar{
						display: none !important;
					}
					.site-header:not(.header-transparent).header-scrolled .main-bar{
						background: rgba(12, 14, 22, 0.55) !important;
						backdrop-filter: blur(18px) saturate(180%) !important;
						-webkit-backdrop-filter: blur(18px) saturate(180%) !important;
						border-bottom: 1px solid rgba(255,255,255,0.08);
					}
				`}</style>
				<header className={`site-header${this.state.isScrolled ? ' header-scrolled' : ''} `}>
					<HeaderContent />
				</header>
			</Fragment>
		)
	}
}
export default Header2;